<p-dialog
  [header]="currentState ? currentState.headerText : 'Информация'"
  class="ui-dialog-component"
  [closable]="currentState && currentState.closable !== undefined ? currentState.closable : true"
  [class.max-width-window]="isMaximizableDisplay"
  [ngClass]="currentState.styleClass"
  [styleClass]="'common-dialog'"
  [(visible)]="isDialogVisible"
  [id]="currentState"
  (onShow)="onShow($event)"
  (onMaximize)="onMaximize($event)"
  [responsive]="false"
  [minY]="70"
  [modal]="true"
  [maximizable]="true"
  [baseZIndex]="10000"
>
  <div class="common-dialog__content">
    <ng-container [ngSwitch]="currentState.type">
      <ng-container *ngSwitchCase="dialogEnum.Info">
        <ng-container *ngTemplateOutlet="defaultTextTmpl"> </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="dialogEnum.Success">
        <ng-container *ngTemplateOutlet="successTmpl"> </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="dialogEnum.Error">
        <ng-container *ngTemplateOutlet="defaultTextTmpl"> </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="dialogEnum.Confirm">
        <ng-container *ngTemplateOutlet="confirmTmpl"> </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="dialogEnum.HtmlContent">
        <ng-container *ngTemplateOutlet="htmlContentTmpl"> </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="dialogEnum.Captcha">
        <ng-container *ngTemplateOutlet="captchaTmpl"> </ng-container>
      </ng-container>
    </ng-container>
  </div>
  <p-footer>
    <div class="common-dialog__footer">
      <button
        *ngIf="currentState.onAccept"
        class="btn btn__white-with-shadow"
        id="acceptBtn"
        type="button"
        [autofocus]="currentState.onAccept"
        [disabled]="currentState.type === dialogEnum.Captcha && !(isCaptchaPassed | async)"
        (click)="onAccept($event)"
      >
        {{ currentState.acceptButtonLabel ? currentState.acceptButtonLabel : 'Продолжить' }}
      </button>
      <button
        *ngIf="!currentState.actions"
        class="btn btn__white-with-shadow close-btn"
        id="closeWindow"
        type="button"
        [autofocus]="currentState.type !== dialogEnum.Confirm"
        (click)="onClose()"
      >
        {{ currentState.closeButtonLabel ? currentState.closeButtonLabel : 'Закрыть' }}
      </button>
    </div>
  </p-footer>
</p-dialog>

<ng-template #defaultTextTmpl>
  {{ currentState.content }}
</ng-template>

<ng-template #successTmpl>
  <div class="dialog-container">
    <div class="message-container">
      {{ currentState.content }}
    </div>
  </div>
</ng-template>

<ng-template #confirmTmpl>
  <div *ngFor="let paragraph of currentState.content">{{ paragraph }} <br /></div>
</ng-template>

<ng-template #htmlContentTmpl>
  <p [innerHTML]="currentState.content"></p>
</ng-template>

<ng-template #captchaTmpl>
  <div class="dialog-container">
    <div class="message-container">
      <p [innerHTML]="currentState.content"></p>

      <app-captcha [showCaptcha]="isCaptchaVisible | async"></app-captcha>
    </div>
  </div>
</ng-template>
